module.exports = __webpack_public_path__ + "img/Mail.88c377d9.svg";